import React from 'react';
import Input from './Input';

/**
 * @type {import('./types').FieldTransformStrategy}
 */
const transform = {
  fromServer: Input.transform.fromServer,
  toServer: Input.transform.toServer,
  defaultValue: Input.transform.defaultValue,
};

const Hyperlink = React.memo(function Hyperlink(props) {
  return <Input type="url" {...props} />;
});

Hyperlink.transform = transform;
export default Hyperlink;
